module.exports = __webpack_public_path__ + "static/img/4.fdefe212.png";